import { Image } from "expo-image";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import Button from "../Button";
import localGraphic from "./score-empty-state.png";

const GRAPHIC_WIDTH = 160;
const GRAPHIC_HEIGHT = 120;
const MESSAGE_MAX_WIDTH = 316;

export type ProficiencyScoresEmptyCopy = {
	title: string;
	subtitle: string;
	cta?: string;
	/** Partner-configured illustration; falls back to the bundled default. */
	graphicUrl?: string;
};

export type ProficiencyScoresEmpty = ProficiencyScoresEmptyCopy & {
	onPressCta?: () => void;
};

export const ProficiencyScoresEmptyState = ({
	title,
	subtitle,
	cta,
	graphicUrl,
	onPressCta,
}: ProficiencyScoresEmpty) => {
	const theme = useAppTheme();

	return (
		<Box gap={24} alignItems="center">
			<Box gap={24} alignItems="center">
				<Image
					source={graphicUrl ?? localGraphic}
					style={{ width: GRAPHIC_WIDTH, height: GRAPHIC_HEIGHT }}
					contentFit="contain"
					accessibilityIgnoresInvertColors
					importantForAccessibility="no"
					aria-hidden
				/>
				<Box
					gap={8}
					alignItems="center"
					width="100%"
					maxWidth={MESSAGE_MAX_WIDTH}
				>
					<Text variant="titleLarge" style={{ textAlign: "center" }}>
						{title}
					</Text>
					<Text
						variant="bodyMedium"
						style={{
							color: theme.colors.onSurfaceVariant,
							textAlign: "center",
						}}
					>
						{subtitle}
					</Text>
				</Box>
			</Box>
			{cta && onPressCta ? (
				<Button
					mode="contained"
					icon="play-circle-outline"
					onPress={onPressCta}
				>
					{cta}
				</Button>
			) : null}
		</Box>
	);
};
